import React, { Component,Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoute from "../app/components/PrivateRoute"

import Spinner from '../app/shared/Spinner';

const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const CategoryDetail = lazy(() => import('./dashboard/CategoryDetail'));
const CategoryEdit = lazy(() => import('./dashboard/CategoryEdit'));
const PrivacyPolicy = lazy(() => import('./privacy/PrivacyPolicy'));
const Buttons = lazy(() => import('./basic-ui/Buttons'));
const Dropdowns = lazy(() => import('./basic-ui/Dropdowns'));
const Typography = lazy(() => import('./basic-ui/Typography'));
const BasicElements = lazy(() => import('./form-elements/BasicElements'));
const BasicTable = lazy(() => import('./tables/BasicTable'));
const Mdi = lazy(() => import('./icons/Mdi'));
const Error404 = lazy(() => import('./error-pages/Error404'));
const Error500 = lazy(() => import('./error-pages/Error500'));
const Login = lazy(() => import('./components/Login'));
class AppRoutes extends Component {
  render () {
    return (

      <Suspense fallback={<Spinner/>}>
        <Switch>
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <PrivateRoute exact path="/category-detail/:id" component={CategoryDetail} />
          <PrivateRoute exact path="/category-edit/:id" component={CategoryEdit} />
          <Route path="/basic-ui/buttons" component={ Buttons } />
          <Route path="/basic-ui/dropdowns" component={ Dropdowns } />
          <Route path="/basic-ui/typography" component={ Typography } />
          <Route path="/forms" component={ BasicElements } />
          <Route path="/tables" component={ BasicTable } />
          <Route path="/icons" component={ Mdi } />
          <Route path="/login" component={ Login } />
          <Route path="/privacy-policy" component={ PrivacyPolicy } />
          <Route path="/error-pages/error-404" component={ Error404 } />
          <Route path="/error-pages/error-500" component={ Error500 } />
          <Redirect to="/login" />
        </Switch>
      </Suspense>

    );
  }
}

export default AppRoutes;